import React from 'react'
import AlertEventTable from './AlertEventTable'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function AlertEvents() {
  SetTitle('SEO Sentinel Check')
	return (
    <Header
      iconClass="ni ni-compass-04 text-white"
      title="SEO Sentinel Check"
    >
      <AlertEventTable />
    </Header>
	)
}